import React, { useState } from "react";
import { Modal, Button, Form, Input, Select, Row, Col, notification } from "antd";
import DropdownContainer from "../DropdownContainer";
import { useSelector } from "react-redux";
import { useUpdateUserAccessLevelMutation } from "../../redux/api/userManagementApi";

const AddUserModal = () => {
  const jwtToken = useSelector((state) => state.oauth.auth0Token);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [form] = Form.useForm();
  const [updateUserAccessLevel] = useUpdateUserAccessLevelMutation();
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    form.validateFields()
      .then((values) => {
        console.log('Form values:', values);
        form.resetFields();
        setIsModalVisible(false);
        updateUserAccessLevel({
          accessLevel: values.access_level,
          userEmail: values.email,
          clientName: values.client
        }).unwrap().then(() => {
          notification.success({
            message: "User Access Level Updated",
            description: "The user access level has been updated successfully.",
          });
        });
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
  };

  const handleAccessLevelChange = (value) => {
    setShowClientDropdown(value === 'client');
  };

  return (
    <div style={{
      marginTop: "10px",
    }}>
      <Button type="primary" onClick={showModal}>
        Add Permission
      </Button>
      <Modal
        title="Add Permission"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Add Permission"
        width="100vw"
        height="100vh"
        style={{
          width: "100vw",
          height: "100vh",
        }}
      >
            <p>Add a new user to the system. This user will be able to access the system and perform actions. Please only do this if you know what you are doing.</p>
        <Form
          form={form}
          layout="vertical"
          name="add_user_form"
        >
          <Row gutter={16}>
            <Col span={6}>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: 'Please input the email!' },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
              >
                <Input placeholder="Enter email address" />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                name="access_level"
                label="Access Level"
                rules={[{ required: true, message: 'Please select an access level!' }]}
              >
                <Select
                  placeholder="Select access level"
                  onChange={handleAccessLevelChange}
                  options={[
                    { value: 'admin', label: 'Admin' },
                    { value: 'internal', label: 'Internal User' },
                    {value: 'client', label: 'Client'}
                  ]}
                />
              </Form.Item>
            </Col>
            {showClientDropdown && (
            <Col span={6}>
            <Form.Item
              name="client"
              label="Select Client"
            >
              <DropdownContainer
                dropdown_name="client_name"
                includeTitle={false}
                extraApiParams={{
                  jwt_token: jwtToken
                }}
              />
            </Form.Item>
            </Col>
          )}
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUserModal;
